import { render } from "./audiences-metrics.vue?vue&type=template&id=547d84f4"
import script from "./audiences-metrics.vue?vue&type=script&lang=js"
export * from "./audiences-metrics.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__